<template>
    <div class="menu">
        <div class="cursor-pointer font-bold flex items-center"
             :class="opened==='/' ? 'text-white':'text-gray-300'"
             @click="opened='/'">
            <div class="mr-2">
                <span class="text-black" >•</span>
            </div>
            <router-link to="/">Home</router-link>
        </div>
        <div v-for="menuItem in menu">
                <div
                        class="cursor-pointer font-bold flex items-center"
                        :class="opened===menuItem.path ? 'text-white':'text-gray-300'"
                        @click="opened=menuItem.path">
                    <div class="mr-2">
                        <span :class="opened===menuItem.path ? 'text-white':'text-black'">•</span>
                    </div>
                    <div>{{menuItem.title}}</div>
                </div>
                <div class="ml-6" v-for="anchor in menuItem.items" v-if="opened===menuItem.path">
                    <router-link
                            :to="{path:menuItem.path,hash:anchor.path}">{{anchor.title}}
                    </router-link>
                </div>
        </div>
    </div>
</template>
<script>
    import {menu} from "../settings";

    export default {
        name: 'main-menu',
        data() {
            return {
                menu: menu,
                opened: null
            }
        },
        watch:{
            $route (to, from){
                this.opened = to.path.replace('/', '');
            }
        },
        mounted() {
            this.opened = this.$route.path.replace('/', '');
        }
    }
</script>
<style lang="scss" scoped>
    .menu {
        a {
            @apply text-gray-300;
            &.router-link-active {
                color: #fff !important;
            }
        }
    }

</style>
